import { render, staticRenderFns } from "./show-grid-tile.vue?vue&type=template&id=013d9032&scoped=true&"
import script from "./show-grid-tile.vue?vue&type=script&lang=js&"
export * from "./show-grid-tile.vue?vue&type=script&lang=js&"
import style0 from "./show-grid-tile.vue?vue&type=style&index=0&id=013d9032&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013d9032",
  null
  
)

export default component.exports